import React, { Component } from "react";
import * as actionCreators from "./actions";
import ScheduleCleaningComponent from "./ScheduleCleaningComponent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRooms } from "../../rooms/actions";
import { getCleaningList } from "../actions";
import { getUsers } from "../../users/actions";
import { translate } from "react-i18next";
class ScheduleCleaningContainer extends Component {
  state = { checked: false };
  componentWillMount() {
    if (this.props.rooms.length === 0) {
      this.props.getRooms();
    }

    if (this.props.cleaningList.length === 0) {
      this.props.getCleaningList();
    }

    if (this.props.users.length === 0) {
      this.props.getUsers();
    }
  }

  toggleCheckBox = () => {
    this.setState(prevState => ({ checked: !prevState.checked }));
  };
  render() {
    return (
      <ScheduleCleaningComponent
        {...this.state}
        {...this.props}
        toggleCheckBox={this.toggleCheckBox}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  selectedCleaner: state.scheduleCleaning.selectedCleaner,
  cleaners: state.users.data,
  rooms: state.rooms.data,
  users: state.users.data,
  cleaningList: state.cleaning.data
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    { ...actionCreators, getRooms, getCleaningList, getUsers },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(ScheduleCleaningContainer));



// WEBPACK FOOTER //
// ./src/cleaning/schedule/ScheduleCleaningContainer.js